import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon.js';
import Avatar from './Avatar.js';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';
import { p as props, d as defaults } from './componentEl-33ff2aeb.js';
import './_variables.es6-3122d3a2.js';

function Token(_ref) {
  let {
    componentEl: Component,
    avatar,
    className,
    caps,
    color,
    children,
    margin,
    icon,
    onDismiss
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "avatar", "className", "caps", "color", "children", "margin", "icon", "onDismiss"]);

  let cssClasses = ['st_token', "st_token--" + color];
  let avatarProps = {};
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  if (caps) cssClasses.push('st_token--caps');

  if (avatar) {
    cssClasses.push('st_token--with-avatar');
    avatarProps = {
      avatar: avatar.avatar,
      initials: avatar.initials,
      size: 'md',
      className: 'st_token__avatar'
    };
  }

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), icon && /*#__PURE__*/React.createElement(Icon, {
    className: "st_token__icon",
    type: icon,
    size: "smd"
  }), avatar && /*#__PURE__*/React.createElement(Avatar, avatarProps), children && /*#__PURE__*/React.createElement("div", {
    className: "st_token__children"
  }, children), onDismiss && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onDismiss,
    className: "st_token__dismiss",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "cross",
    size: "smd"
  })));
}

Token.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** props for optional avatar, if any, only accepts avatar and initials */
  avatar: PropTypes.shape({
    avatar: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    initials: PropTypes.string
  }),

  /** whether token text should be ALL CAPS */
  caps: PropTypes.bool,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** color of token */
  color: PropTypes.oneOf(['blurple', 'gray', 'rose', 'lava', 'tangerine', 'sunshine', 'emerald', 'ice']),

  /** callback when dismiss button is clicked, also toggles display of it */
  onDismiss: PropTypes.func,

  /** left/top/right/bottom, and also size */
  margin: marginProps,

  /** optional icon for token */
  icon: PropTypes.string
};
Token.defaultProps = {
  componentEl: defaults,
  avatar: null,
  caps: false,
  className: null,
  color: 'gray',
  onDismiss: null,
  margin: null,
  icon: null
};

export default Token;
